import { render, staticRenderFns } from "./BatchCorrection.vue?vue&type=template&id=372dfd40&"
import script from "./BatchCorrection.vue?vue&type=script&lang=js&"
export * from "./BatchCorrection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports